module.exports = {
      id: "mobile-share-usage",
      viewBox: "0 0 16.211 17.807",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#mobile-share",
      toString: function () {
        return this.url;
      }
    }